import {Inject, Injectable} from '@angular/core';
import {DataRequirements, DataRequirementsInjectionToken} from '../data.requirements';
import {TeacherListMapper} from '../mappers/teacher-list.mapper';

@Injectable({
    providedIn: 'root'
})
export class TeacherListUseCase {
    constructor(
        private mapper: TeacherListMapper,
        @Inject(DataRequirementsInjectionToken) private data: DataRequirements
    ) {}

    run() {
      return this.data.getTeacherList().pipe(this.mapper.map);
    }
}
